import { Box, InputCheckBox } from "@itandi/itandi-bb-ui";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { DealSearchCondition, DealType } from "~/models/Deal";

type Props = {
	dealSubtypeId?: number;
	dealType: DealType;
	label: string;
};

export function DealTypeCheckBox({ dealType, dealSubtypeId, label }: Props) {
	const { setValue, getValues, control } =
		useFormContext<DealSearchCondition>();
	const watchedDealTypes = useWatch({ control, name: "dealTypes" });
	const watchedDealSubtypeIds = useWatch({ control, name: "dealSubtypeIds" });
	const checked = React.useMemo((): boolean => {
		if (watchedDealTypes) {
			if (["restoration", "repair"].includes(dealType)) {
				return watchedDealTypes.includes(dealType);
			}
			return (
				watchedDealTypes.includes(dealType) &&
				!!dealSubtypeId &&
				(watchedDealSubtypeIds?.includes(dealSubtypeId) ?? false)
			);
		}
		return false;
	}, [watchedDealTypes, watchedDealSubtypeIds, dealType, dealSubtypeId]);

	const onDealTypeChange = React.useCallback((): void => {
		const dealTypes = [...(getValues("dealTypes") ?? [])];
		const dealSubtypeIds = [...(getValues("dealSubtypeIds") ?? [])];
		if (!checked) {
			// 追加
			if (!dealTypes.includes(dealType)) {
				dealTypes.push(dealType);
			}
			if (dealSubtypeId && !dealSubtypeIds.includes(dealSubtypeId)) {
				dealSubtypeIds.push(dealSubtypeId);
			}
		} else {
			// 削除
			if (dealSubtypeId && dealSubtypeIds.includes(dealSubtypeId)) {
				dealSubtypeIds.splice(dealSubtypeIds.indexOf(dealSubtypeId), 1);
			}
			if (dealTypes.includes(dealType)) {
				if (dealType === "other") {
					if (dealSubtypeIds.length === 0) {
						dealTypes.splice(dealTypes.indexOf(dealType), 1);
					}
				} else {
					dealTypes.splice(dealTypes.indexOf(dealType), 1);
				}
			}
		}
		setValue("dealTypes", dealTypes);
		setValue("dealSubtypeIds", dealSubtypeIds);
	}, [checked, dealSubtypeId, dealType, getValues, setValue]);
	return (
		<Box margin={4} minWidth={0}>
			<InputCheckBox
				checked={checked}
				label={label}
				onChange={onDealTypeChange}
			/>
		</Box>
	);
}
